import { z } from 'zod';

export const seasonFieldSchema = z.object({
  id: z.string(),
  field_id: z.string(),
  name: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  varieties_ids: z.array(z.string()),
  property_id: z.string().optional(),
  season_id: z.string().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  planting_date: z.string().optional(),
  emergency_date: z.string().optional(),
  harvesting_date: z.string().optional(),
  declared_area: z.number().optional(),
  calculated_area: z.number().optional()
});
